var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, useState, } from 'react';
import { applyTheme, DefaultTheme, WhiteLabelTheme } from '../theme';
import { Storage } from '@capacitor/storage';
const ThemeContext = createContext({});
function ThemeProvider({ children, themeEndPoint, overRideCache, }) {
    const [data, setData] = useState({});
    const [theme, setTheme] = useState();
    const getData = () => __awaiter(this, void 0, void 0, function* () {
        const { value } = yield Storage.get({ key: 'storageTheme' });
        if (!value || overRideCache) {
            yield fetch(themeEndPoint, { cache: 'no-store' })
                .then(function (res) {
                return __awaiter(this, void 0, void 0, function* () {
                    let res2 = res.clone();
                    let themeData = yield res2.json();
                    Promise.all([
                        caches.open('json-files').then((cache) => {
                            cache.put(themeEndPoint, res);
                        }),
                        caches.open('images').then((cache) => cache
                            .addAll([
                            themeData.images.graphicOverlayUrl,
                            themeData.images.logoUrl,
                            themeData.images.faviconUrl,
                            themeData.images.portalLoginLogoUrl,
                            themeData.images.portalLoginBackgroundUrl,
                        ].filter(Boolean))
                            .catch((err) => console.warn('Theme images were not pre-cached', err))),
                        Storage.set({
                            key: 'storageTheme',
                            value: JSON.stringify(themeData),
                        }),
                    ]);
                    setData(themeData);
                });
            })
                .catch(function (err) {
                console.error(err);
                setWhiteLabelTheme();
            });
        }
        else {
            setData(JSON.parse(value));
        }
    });
    useEffect(() => {
        getData();
    }, [themeEndPoint]);
    useEffect(() => {
        if (data === null || data === void 0 ? void 0 : data.colors) {
            if (data.colors) {
                DefaultTheme.primary = data.colors.primary;
                DefaultTheme.secondary = data.colors.secondary;
                DefaultTheme.tertiary = data.colors.tertiary;
                DefaultTheme.primaryAccent1 = data.colors.primaryAccent1;
                DefaultTheme.primaryAccent2 = data.colors.primaryAccent2;
                DefaultTheme.secondaryAccent1 = data.colors.secondaryAccent1;
                DefaultTheme.secondaryAccent2 = data.colors.secondaryAccent2;
                DefaultTheme.tertiaryAccent1 = data.colors.tertiaryAccent1;
                DefaultTheme.tertiaryAccent2 = data.colors.tertiaryAccent2;
                DefaultTheme.textDark = WhiteLabelTheme.textDark;
                DefaultTheme.textMid = WhiteLabelTheme.textMid;
                DefaultTheme.textLight = WhiteLabelTheme.textLight;
                DefaultTheme.uiMidDark = WhiteLabelTheme.uiMidDark;
                DefaultTheme.uiMid = WhiteLabelTheme.uiMid;
                DefaultTheme.uiLight = WhiteLabelTheme.uiLight;
                DefaultTheme.uiBg = WhiteLabelTheme.uiBg;
                DefaultTheme.modalBg = WhiteLabelTheme.modalBg;
                DefaultTheme.errorMain = WhiteLabelTheme.errorMain;
                DefaultTheme.errorDark = WhiteLabelTheme.errorDark;
                DefaultTheme.errorBg = WhiteLabelTheme.errorBg;
                DefaultTheme.alertMain = WhiteLabelTheme.alertMain;
                DefaultTheme.alertDark = WhiteLabelTheme.alertDark;
                DefaultTheme.alertBg = WhiteLabelTheme.alertBg;
                DefaultTheme.successMain = WhiteLabelTheme.successMain;
                DefaultTheme.successDark = WhiteLabelTheme.successDark;
                DefaultTheme.successBg = WhiteLabelTheme.successBg;
                DefaultTheme.infoMain = WhiteLabelTheme.infoMain;
                DefaultTheme.infoDark = WhiteLabelTheme.infoDark;
                DefaultTheme.infoBb = WhiteLabelTheme.infoBb;
                DefaultTheme.infoBb = WhiteLabelTheme.infoBb;
                DefaultTheme.darkBackground = WhiteLabelTheme.darkBackground;
                DefaultTheme.quatenary = WhiteLabelTheme.quatenary;
                DefaultTheme.quatenaryMain = WhiteLabelTheme.quatenaryMain;
                DefaultTheme.adminPortalBg = WhiteLabelTheme.adminPortalBg;
                DefaultTheme.darkBlue = WhiteLabelTheme.darkBlue;
                DefaultTheme.pointsCardBg = WhiteLabelTheme.pointsCardBg;
                DefaultTheme.pointsCardBarBg = WhiteLabelTheme.pointsCardBarBg;
                DefaultTheme.quatenaryBg = WhiteLabelTheme.quatenaryBg;
                DefaultTheme.adminBackground = WhiteLabelTheme.adminBackground;
                DefaultTheme.quinary = WhiteLabelTheme.quinary;
            }
            if (data.images) {
                DefaultTheme.logoUrl = `url(${data.images.logoUrl})`;
                DefaultTheme.graphicOverlayUrl = `url(${data.images.graphicOverlayUrl})`;
                DefaultTheme.faviconUrl = data.images.faviconUrl;
                DefaultTheme.portalLoginLogoUrl = data.images.portalLoginLogoUrl;
                DefaultTheme.portalLoginBackgroundUrl =
                    data.images.portalLoginBackgroundUrl;
            }
            if (data.fonts) {
                DefaultTheme.fontUrl = "'Quicksand', sans-serif";
                DefaultTheme.mainHeadingOverrideFontUrl =
                    data.fonts.mainHeadingOverrideFontUrl;
            }
            applyTheme();
            overRideTheme(data);
        }
    }, [data]);
    function setWhiteLabelTheme() {
        DefaultTheme.primary = WhiteLabelTheme.primary;
        DefaultTheme.primaryAccent1 = WhiteLabelTheme.primaryAccent1;
        DefaultTheme.primaryAccent2 = WhiteLabelTheme.primaryAccent2;
        DefaultTheme.secondary = WhiteLabelTheme.secondary;
        DefaultTheme.secondaryAccent1 = WhiteLabelTheme.secondaryAccent1;
        DefaultTheme.secondaryAccent2 = WhiteLabelTheme.secondaryAccent2;
        DefaultTheme.tertiary = WhiteLabelTheme.tertiary;
        DefaultTheme.tertiaryAccent1 = WhiteLabelTheme.tertiaryAccent1;
        DefaultTheme.tertiaryAccent2 = WhiteLabelTheme.tertiaryAccent2;
        DefaultTheme.textDark = WhiteLabelTheme.textDark;
        DefaultTheme.textMid = WhiteLabelTheme.textMid;
        DefaultTheme.textLight = WhiteLabelTheme.textLight;
        DefaultTheme.uiMidDark = WhiteLabelTheme.uiMidDark;
        DefaultTheme.uiMid = WhiteLabelTheme.uiMid;
        DefaultTheme.uiLight = WhiteLabelTheme.uiLight;
        DefaultTheme.uiBg = WhiteLabelTheme.uiBg;
        DefaultTheme.modalBg = WhiteLabelTheme.modalBg;
        DefaultTheme.errorMain = WhiteLabelTheme.errorMain;
        DefaultTheme.errorDark = WhiteLabelTheme.errorDark;
        DefaultTheme.errorBg = WhiteLabelTheme.errorBg;
        DefaultTheme.alertMain = WhiteLabelTheme.alertMain;
        DefaultTheme.alertDark = WhiteLabelTheme.alertDark;
        DefaultTheme.alertBg = WhiteLabelTheme.alertBg;
        DefaultTheme.successMain = WhiteLabelTheme.successMain;
        DefaultTheme.successDark = WhiteLabelTheme.successDark;
        DefaultTheme.successBg = WhiteLabelTheme.successBg;
        DefaultTheme.infoMain = WhiteLabelTheme.infoMain;
        DefaultTheme.infoDark = WhiteLabelTheme.infoDark;
        DefaultTheme.infoBb = WhiteLabelTheme.infoBb;
        DefaultTheme.fontUrl = WhiteLabelTheme.fontUrl;
        DefaultTheme.mainHeadingOverrideFontUrl =
            WhiteLabelTheme.mainHeadingOverrideFontUrl;
        DefaultTheme.darkBackground = WhiteLabelTheme.darkBackground;
        DefaultTheme.quatenary = WhiteLabelTheme.quatenary;
        DefaultTheme.quatenaryMain = WhiteLabelTheme.quatenaryMain;
        DefaultTheme.adminPortalBg = WhiteLabelTheme.adminPortalBg;
        DefaultTheme.darkBlue = WhiteLabelTheme.darkBlue;
        DefaultTheme.pointsCardBg = WhiteLabelTheme.pointsCardBg;
        DefaultTheme.pointsCardBarBg = WhiteLabelTheme.pointsCardBarBg;
        DefaultTheme.quatenaryBg = WhiteLabelTheme.quatenaryBg;
        DefaultTheme.adminBackground = WhiteLabelTheme.adminBackground;
        DefaultTheme.quinary = WhiteLabelTheme.quinary;
    }
    function overRideTheme(theme) {
        setTheme(theme);
    }
    const memoedValue = useMemo(() => ({
        theme,
        overRideTheme,
        setWhiteLabelTheme,
    }), [theme]);
    return (_jsx(ThemeContext.Provider, Object.assign({ value: memoedValue }, { children: children })));
}
export { ThemeProvider, ThemeContext };
export function useTheme() {
    return useContext(ThemeContext);
}
//# sourceMappingURL=useTheme.js.map